jQuery(document).ready(function ($) {
    $(document).on('click', '.careers__apply', function () {

        var count = $(this).data('count');
        var jobDesc = $('[data-job-desc=' + count + ']').html();
        var jobPosition = $(this).data('job-position');
        $('#jobDesc').html(jobDesc);

        $('#careersPosition').val(jobPosition);

        $('#modalApply').modal('show');
    })
})
